import React, {useContext} from "react";
import {HorizontalSeparator} from "../../separators/Separators";
import LineMeaningComponent from "./LineMeaningComponent";
import HerfindalChart from "../../Charts/HerfindalChart";
import {GlobalDataContext} from "../../../contexts/GlobalDataContext";
import {useTranslation} from "react-i18next";
import styled from "styled-components";
import HerfindahlRecord from "../../../models/HerfindahlRecord";
import ChartWithTextDescription from "../../ChartWithTextDescription/ChartWithTextDescription";
import TwoColumnsLayout from "../../TwoColumnsLayout/TwoColumnsLayout";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  & .marketClusterText {
    flex: 1 1 auto;
    padding-right: 100px;

    & .marketAnalysisText {
      margin-top: 36px;
    }
  }

  & .marketClusterChart {
    flex: 1 1 auto;
    width: 70%;
  }

  & .marketClusterGraphicContainer {
    flex: 1 1 auto;
  }

  & .seeMoreDetails {
    font-family: AvenirNextLTPro-HeavyCn;
    cursor: pointer;
    margin-top: 80px;

    &::after {
      display: inline-block;
      content: '';
      border-top: 4px solid transparent;
      border-bottom: 4px solid transparent;
      border-left: 8px solid white;
      margin-left: 13px;
      height: 0px;
    }
  }

  @media (max-width: 480px) {
    & .marketClusterText {
      padding-right: 0px;
    }

    & .marketClusterChart {
      width: 100%;
    }

    & .seeMoreDetails {
      margin-top: 0;
    }
  }
`;

const HerfindalContainer = styled.div`
  display: flex;
  flex: 1 0 auto;

  @media (max-width: 480px) {
    display: block;
  }
`;

const MarketClusteringContentComponent: React.FC<{openDetails: () => void}> = ({openDetails}) => {
    const { t } = useTranslation();
    // @ts-ignore
    const { latamHerfindahlRecords } = useContext(GlobalDataContext);

    const firstYear = Math.min(...latamHerfindahlRecords.map((x: HerfindahlRecord) => x.year));
    const lastYear = Math.max(...latamHerfindahlRecords.map((x: HerfindahlRecord) => x.year));

    return (
      <TwoColumnsLayout
        leftColumnChildren={
          <>
            <h3 className={'marginTop50'}>
              { t('latamMarketConcentration.paragraphTitle') }
            </h3>
            <HorizontalSeparator width={50}/>
            <p className={'marketAnalysisText'}>
              {t('latamMarketConcentration.paragraph')}
            </p>
            <div className='see-more-details' onClick={openDetails}>
              { t('latamMarketConcentration.seeMoreDetails') }
            </div>
          </>
        }
        rightColumnChildren={
          <div className='chart-container' style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <h3 style={{ flex: '0 0 auto' }}>{ t('latamMarketConcentration.subtitle') }</h3>
            <div className={'chartSubTitleMC'} style={{ flex: '0 0 auto' }}>
              { t('latamMarketConcentration.firstChartSubtitle', { yearStart: firstYear, yearEnd: lastYear }) }
            </div>
            <div style={{ flex: '0 0 auto' }}>
              <LineMeaningComponent/>
            </div>
            <HerfindalContainer>
              <HerfindalChart series={latamHerfindahlRecords} customStyle={{ height: '100%' }}/>
            </HerfindalContainer>
          </div>
        }
      />
    )
};

export default MarketClusteringContentComponent;
